function fnumber(number) {
  // const n = new Intl.NumberFormat("id-ID").format(number);

  return new Intl.NumberFormat("id-ID").format(number);
}

export { fnumber };
